export default __webpack_public_path__ + "static/media/vendor-icon-gray.432b3342.svg";